import { Box } from "@mui/material";
import { useEffect } from "react";
import style from "./index.module.css";
import "react-multi-carousel/lib/styles.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { IoMdClose } from "react-icons/io";

import img1 from "../../../assets/how_its_work/Rectangle1.png";
import img2 from "../../../assets/how_its_work/Rectangle2.png";
import img3 from "../../../assets/how_its_work/Rectangle3.png";
import img4 from "../../../assets/how_its_work/Rectangle4.png";
// import img5 from "../../../assets/how_its_work/Rectangle5.png";
import img5 from "../../../assets/how_its_work/Rectangle5.png";
import img6 from "../../../assets/how_its_work/Rectangle6.png";
import img7 from "../../../assets/how_its_work/Rectangle7.png";
import img8 from "../../../assets/how_its_work/Rectangle8.png";
import img9 from "../../../assets/how_its_work/Rectangle9.png";

const SLIDE_DATA = [
  { title: "Share the link", img: img1 },
  {
    title: (
      <div>
        Customer receives <br />
        e-Visa link
      </div>
    ),
    img: img2,
  },
  { title: "Gets on the Visa App", img: img3 },
  { title: "Apply for Visa", img: img4 },
  { title: "Choose Visa", img: img5 },
  { title: "Document upload", img: img6 },
  { title: "Visa form review", img: img7 },
  { title: "Customer Payment", img: img8 },
  { title: "Amount for You", img: img9 },
];

export default function HowItsWork_Carousel({ close }) {
  useEffect(() => {
    const handleTouchMove = (e) => {
      e.preventDefault();
    };
    window.addEventListener("touchmove", handleTouchMove, { passive: false });
    return () => {
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "#f07821",
        height: "100svh",
        width: "100vw",
        position: "fixed",
      }}
    >
      {/* Close button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          padding: "1rem",
        }}
        onClick={() => close()}
      >
        <IoMdClose className={style.close_icon} />
      </Box>

      {/* Carousel */}
      <Box style={{ height: "85%" }} className="Carousel_section">
        <Carousel
          className="howitworks-carousel"
          showThumbs={false}
          showStatus={false}
          showArrows={false}
          showIndicators={true}
          infiniteLoop
          renderIndicator={(onClickHandler, isSelected, index) => {
            return (
              <li
                key={index}
                onClick={onClickHandler}
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  margin: "0 6px",
                  marginTop: "30px",
                  background: isSelected ? "#000" : "#FFFFFF",
                  cursor: "pointer",
                  display: "inline-block",
                  transition: "all 0.3s ease",
                }}
              />
            );
          }}
        >
          {SLIDE_DATA.map((item, index) => {
            const { title, img } = item;
            return (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  height: "95svh",
                  position: "relative",
                }}
              >
                {/* Title */}
                <Box
                  sx={{
                    minHeight: "70px", // fixed height ensures consistent layout if text wraps
                    padding: "0 1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <h4
                    style={{
                      fontSize: "1.75rem",
                      fontWeight: "500",
                      color: "white",
                      textAlign: "center",
                      lineHeight: "1.4",
                      margin: 0,
                    }}
                  >
                    {title}
                  </h4>
                </Box>

                {/* Image container */}
                <Box
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    position: "relative",
                  }}
                >
                  <img
                    src={img}
                    style={{
                      position: "absolute",
                      top: "0%",
                      width: "100%",
                      maxHeight: "90%",
                      // width: "auto",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              </Box>
            );
          })}
        </Carousel>
      </Box>
    </Box>
  );
}
